import { ConnectButton } from "@rainbow-me/rainbowkit";
import React, { useContext, useEffect, useState } from "react";
import { ProjectContext } from "../../ProjectContext";
import { useNavigate } from "react-router-dom";

function Header() {
  const { account, dbuser, setdbuser, Refaddress } = useContext(ProjectContext);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Effect to handle navigation if dbuser is invalid or user doesn't have a referral
  useEffect(() => {
    // Ensure dbuser is valid and check if Refaddress is set
    if (!account) {
      navigate("/"); // Navigate to the homepage if dbuser is invalid or no referral address exists
    } else {
      // If referral exists and dbuser is valid, allow access to the dashboard
      navigate("/dashboard"); // Redirect to the dashboard page
    }
  }, [dbuser, navigate, Refaddress]); // Re-run this effect when dbuser or Refaddress changes

  useEffect(() => {
    if (!account) {
      setdbuser(null); // Reset dbuser when the account changes
    }
  }, [account, setdbuser]); // Add setdbuser to dependencies to prevent stale closure

  return (
    <div className="container mx-auto ms-auto" style={{ position: "relative" }}>
      <div
        className="nav d-flex justify-content-between w-100 align-items-center"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 1000,
          backgroundColor: "black",
          padding: "10px 20px",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Logo and Link to Home */}
        <a href="/" className="brand-logo">
          <img src="assets/img/logo.svg" width={120} alt="Logo" />
        </a>

        {/* Connect button for wallet integration */}
        <ConnectButton />
      </div>

      {/* Optionally, you could display a loading spinner here based on `loading` state */}
      {loading && <div className="spinner">Loading...</div>}
    </div>
  );
}

export default Header;
